import { useSelector } from 'src/store/store';
import PostItem from 'src/modules/shared/resultsList/components/postItem';
import VisitorLoginPrompt from 'src/modules/shared/resultsList/components/visitorLoginPrompt';
import { ResultsList } from 'styles-js/resultsList';
import { ElasticSearchPost } from 'src/constants/types';
type Props = {
  isCommunitySearch?: boolean;
  onPostItemClick?: (type: string, postId: number) => void;
  posts: ElasticSearchPost[];
};
export default function PostList({
  isCommunitySearch = false,
  onPostItemClick = () => {},
  posts = []
}: Props): JSX.Element {
  const currentUser = useSelector(({
    context
  }) => context.currentUser);
  const postsList = posts.map(post => <PostItem community={post.community} hideReplies={true} isCommunitySearch={isCommunitySearch} key={post.postId} post={post} onClick={onPostItemClick} />);
  return <ResultsList data-testid="results-posts" data-sentry-element="ResultsList" data-sentry-component="PostList" data-sentry-source-file="postList.tsx">
      {!currentUser ? [...postsList.slice(0, 3), <VisitorLoginPrompt key="visitor-prompt" />, ...postsList.slice(3)] : postsList}
    </ResultsList>;
}